import React from 'react';
import { useStaticQuery, graphql, Link } from 'gatsby';

import LanguageSwitcher from '../LanguageSwitcher';
import FloatingCountryMenu from '../FloatingCountryMenu';
import FooterLinks from '../FooterLinks';
import Social from '../Social';
import WebMap from '../WebMap';
import Wrapper from '../../ui/Wrappers';
import World from '-!svg-react-loader!../../ui/svgs/world.svg';
import { FooterStyled, Foot, Language, Links, RRSS, WMap, CurrentCountry } from './styles';
import Breadcrumbs from '../Breadcrumbs';



import FooterImage from '../../images/legal-footer.jpg';
import LazyLoad from 'react-lazyload';

interface IProps {
  data?: any;
  companyName: string;
  country: string;
  countryCode: string;
  countriesDomain: string;
  lang: string;
  countries: any;
  languages: any;
  translations: any;
  alternates?: any;
  breadcrumbs?: { language: string; countryCode: string; pageHref: any };
}

const Navigation = ({
  breadcrumbs,
  data,
  companyName,
  countries,
  languages,
  country,
  countryCode,
  countriesDomain,
  lang,
  alternates,
  translations: t
}) => {
  const internationalDomain = countries && countries.filter(country => country.international)[0];
  const defaultCountry = countries && countries.filter(el => el.international);
  var mappedSocial = [];
  var mappedLinks = [];
  var mappedWebMap = [];

  const localCountry = countries && countries.filter(el => el.languages.includes(lang));
  let localSocial = [];
  let footerLinks = [];

  data &&
    data.allMenuItems.edges.map(value => {
      if (
        value.node.langcode === lang &&
        value.node.menu_name ===
          `footer-${localCountry ? localCountry[0]?.code : defaultCountry[0].code}`
      ) {
        footerLinks.push(value.node);
      } else if (
        value.node.langcode === lang &&
        value.node.menu_name ===
          `social-${localCountry ? localCountry[0]?.code : defaultCountry[0].code}`
      ) {
        localSocial.push(value.node);
      }
    });

  mappedSocial = localSocial && localSocial.filter(el => el.enabled && el.url);
  mappedLinks =
    footerLinks && footerLinks.filter(el => el.enabled && el.url && el.title === 'footer');

  if (mappedLinks && mappedLinks[0] && mappedLinks[0].childrenMenuItems) {
    if (
      mappedLinks[0].childrenMenuItems[mappedLinks[0].childrenMenuItems.length - 1]?.url !==
      `/${lang}/cookies`
    ) {
      mappedLinks[0].childrenMenuItems.push({
        enabled: true,
        id: 'menu-items-menu_link:cookies',
        langcode: `${lang}`,
        menu_name: `footer-${lang}`,
        title: 'Cookies',
        url: `/${lang}/cookies`,
        weight: mappedLinks[0].childrenMenuItems.length
      });
    }
  }

  mappedWebMap =
    footerLinks && footerLinks.filter(el => el.enabled && el.url && el.title !== 'footer');

    return (
      <>
        <LazyLoad height={200} once offset={100}></LazyLoad>
        <FooterStyled>
          <Wrapper as={WMap}>{mappedWebMap && <WebMap data={mappedWebMap} />} </Wrapper>
          <Wrapper as={RRSS}>
            <div className="title">{t.followUs}</div>
            {mappedSocial && <Social data={mappedSocial} />}
          </Wrapper>
          <Foot>
            <Wrapper className="wrapper">
              <Language>

              <FloatingCountryMenu lang={lang} />


              <LanguageSwitcher
                languages={languages}
                lang={lang}
                alternates={alternates}
                country={country}
              />

              </Language>

              <Links>
                <div className="copyright">
                  © {companyName} {t.copyright} {new Date().getFullYear()}
                </div>
                {mappedLinks && <FooterLinks data={mappedLinks} lang={lang} />}
              </Links>
            </Wrapper>
          </Foot>
        </FooterStyled>
      </>
    );
};

const Footer = ({
  breadcrumbs,
  companyName,
  countries,
  languages,
  country,
  countryCode,
  countriesDomain,
  lang,
  alternates,
  translations
}) => {
  const data = useStaticQuery(graphql`
    query FooterLinksQuery {
      allMenuItems(filter: { parent: { id: { in: [null] } } }) {
        edges {
          node {
            id
            title
            url
            langcode
            enabled
            menu_name
            weight
            childrenMenuItems {
              id
              title
              url
              langcode
              enabled
              menu_name
              weight
            }
          }
        }
      }
    }
  `);

  return (
    <Navigation
      data={data}
      companyName={companyName}
      countries={countries}
      languages={languages}
      country={country}
      countryCode={countryCode}
      countriesDomain={countriesDomain}
      lang={lang}
      alternates={alternates}
      translations={translations}
      breadcrumbs={breadcrumbs}
    />
  );
};

export default Footer;
